module.exports = __webpack_public_path__ + "img/appIcon-menu--Subscriptions.5a9798bf.svg";